// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMapImage_root__oprRn"};